export const OBS_MAIN_CATEGORIES = [
  {
    value: "cat1",
    label: "Dirigé vers l'observateur",
    categoryId: "cat1",
    categorieName: "Dirigé vers l'observateur",
    trans: {
      fr: "Dirigé vers l'observateur",
      en: "Directed towards the observer",
      es: "Dirigido hacia el observador",
      nl: "Gericht op de waarnemer",
      de: "Zum Beobachter gerichtet",
      it: "Rivolto verso l'osservatore",
    },
  },
  {
    value: "cat2",
    label: "Exploration et déplacements",
    categoryId: "cat2",
    categorieName: "Exploration et déplacements",
    trans: {
      fr: "Exploration et déplacements",
      en: "Exploration and locomotion",
      es: "Exploración y movimientos",
      nl: "Verkenning en voortbeweging",
      de: "Erkundung und Fortbewegung",
      it: "Esplorazione e locomozione",
    },
  },
  {
    value: "cat3",
    label: "Comportements sociaux",
    categoryId: "cat3",
    categorieName: "Comportements sociaux",
    trans: {
      fr: "Comportements sociaux",
      en: "Social behaviours",
      es: "Comportamientos sociales",
      nl: "Sociale gedragingen",
      de: "Soziale Verhaltensweisen",
      it: "Comportamenti sociali",
    },
  },
  {
    value: "cat4",
    label: "Comportements alimentaires",
    categoryId: "cat4",
    categorieName: "Comportements alimentaires",
    trans: {
      fr: "Comportements alimentaires",
      en: "Feeding behaviours",
      es: "Comportamientos alimentarios",
      nl: "Voedingsgedrag",
      de: "Fressverhalten",
      it: "Comportamenti alimentari",
    },
  },
  {
    value: "cat5",
    label: "Autres comportements individuels",
    categoryId: "cat5",
    categorieName: "Autres comportements individuels",
    trans: {
      fr: "Autres comportements individuels",
      en: "Individual behaviours",
      es: "Otros comportamientos individuales",
      nl: "Andere individuele gedragingen",
      de: "Andere individuelle Verhaltensweisen",
      it: "Altri comportamenti individuali",
    },
  },
  {
    value: "cat6",
    label: "Vocalisations",
    categoryId: "cat6",
    categorieName: "Vocalisations",
    trans: {
      fr: "Vocalisations",
      en: "Vocalizations",
      es: "Vocalizaciones",
      nl: "Vocalisaties",
      de: "Vokalisationen",
      it: "Vocalizzazioni",
    },
  },
  {
    value: "cat0",
    label: "Autre",
    categoryId: "cat0",
    categorieName: "Autre",
    trans: {
      fr: "Autre",
      en: "Other",
      es: "Otro",
      nl: "Anders",
      de: "Andere",
      it: "Altro",
    },
  },
  // custom
]
export const OBS_ANALYTICS_CATEGORIES = [
  {
    value: "behav1",
    label: "Alimentation",
    categoryId: "behav1",
    categorieName: "Alimentation",
    color: "#FF6666", // Legacy color from colors.js
    trans: {
      fr: "Alimentation",
      en: "Feeding",
      es: "Alimentación",
      nl: "Voeding",
      de: "Ernährung",
      it: "Alimentazione",
    },
  },
  {
    value: "behav2",
    label: "Comportement indésirable",
    categoryId: "behav2",
    categorieName: "Comportement indésirable",
    color: "#990000", // Legacy color from colors.js
    trans: {
      fr: "Comportement indésirable",
      en: "Unwanted behavior",
      es: "Comportamiento indeseable",
      nl: "Ongewenst gedrag",
      de: "Unerwünschtes Verhalten",
      it: "Comportamento indesiderato",
    },
  },
  {
    value: "behav3",
    label: "Exploration et déplacement",
    categoryId: "behav3",
    categorieName: "Exploration et déplacement",
    color: "#0099FF", // Legacy color from colors.js
    trans: {
      fr: "Exploration et déplacement",
      en: "Exploration and movement",
      es: "Exploración y movimiento",
      nl: "Verkenning en beweging",
      de: "Erkundung und Bewegung",
      it: "Esplorazione e movimento",
    },
  },
  {
    value: "behav4",
    label: "Indéterminé",
    categoryId: "behav4",
    categorieName: "Indéterminé",
    color: "#333333", // Legacy color from colors.js
    trans: {
      fr: "Indéterminé",
      en: "Undetermined",
      es: "Indeterminado",
      nl: "Onbepaald",
      de: "Unbestimmt",
      it: "Indeterminato",
    },
  },
  {
    value: "behav5",
    label: "Interaction humain-animal",
    categoryId: "behav5",
    categorieName: "Interaction humain-animal",
    color: "#73D2A4", // Legacy color from colors.js
    trans: {
      fr: "Interaction humain-animal",
      en: "Human-animal interaction",
      es: "Interacción humano-animal",
      nl: "Mens-dier interactie",
      de: "Mensch-Tier-Interaktion",
      it: "Interazione uomo-animale",
    },
  },
  {
    value: "behav6",
    label: "Repos",
    categoryId: "behav6",
    categorieName: "Repos",
    color: "#330099", // Legacy color from colors.js
    trans: {
      fr: "Repos",
      en: "Rest",
      es: "Descanso",
      nl: "Rust",
      de: "Ruhe",
      it: "Riposo",
    },
  },
  {
    value: "behav7",
    label: "Interaction observateur - visiteurs",
    categoryId: "behav7",
    categorieName: "Interaction observateur - visiteurs",
    color: "#73D2A4", // Legacy color from colors.js (same as behav5)
    trans: {
      fr: "Interaction observateur - visiteurs",
      en: "Observer - visitors interaction",
      es: "Interacción observador - visitantes",
      nl: "Observator - bezoekers interactie",
      de: "Beobachter - Besucher Interaktion",
      it: "Interazione osservatore - visitatori",
    },
  },
  {
    value: "behav8",
    label: "Interactions autres espèces",
    categoryId: "behav8",
    categorieName: "Interactions autres espèces",
    color: "#FD9A4E", // Legacy color from colors.js
    trans: {
      fr: "Interactions autres espèces",
      en: "Interactions with other species",
      es: "Interacciones con otras especies",
      nl: "Interactie met andere soorten",
      de: "Interaktion mit anderen Arten",
      it: "Interazioni con altre specie",
    },
  },
  {
    value: "behav9",
    label: "Non visible",
    categoryId: "behav9",
    categorieName: "Non visible",
    color: "#000000", // Legacy color from colors.js
    trans: {
      fr: "Non visible",
      en: "Not visible",
      es: "No visible",
      nl: "Niet zichtbaar",
      de: "Nicht sichtbar",
      it: "Non visibile",
    },
  },
  {
    value: "behav10",
    label: "Observation",
    categoryId: "behav10",
    categorieName: "Observation",
    color: "#9933FF", // Legacy color from colors.js
    trans: {
      fr: "Observation",
      en: "Observation",
      es: "Observación",
      nl: "Observatie",
      de: "Beobachtung",
      it: "Osservazione",
    },
  },
  {
    value: "behav11",
    label: "Social - indéterminé",
    categoryId: "behav11",
    categorieName: "Social - indéterminé",
    color: "#FFFCCC", // Legacy color from colors.js
    trans: {
      fr: "Social - indéterminé",
      en: "Social - undetermined",
      es: "Social - indeterminado",
      nl: "Sociaal - onbepaald",
      de: "Sozial - unbestimmt",
      it: "Sociale - indeterminato",
    },
  },
  {
    value: "behav12",
    label: "Social - négatif",
    categoryId: "behav12",
    categorieName: "Social - négatif",
    color: "#CC9900", // Legacy color from colors.js
    trans: {
      fr: "Social - négatif",
      en: "Social - negative",
      es: "Social - negativo",
      nl: "Sociaal - negatief",
      de: "Sozial - negativ",
      it: "Sociale - negativo",
    },
  },
  {
    value: "behav13",
    label: "Social - positif",
    categoryId: "behav13",
    categorieName: "Social - positif",
    color: "#FFCC33", // Legacy color from colors.js
    trans: {
      fr: "Social - positif",
      en: "Social - positive",
      es: "Social - positivo",
      nl: "Sociaal - positief",
      de: "Sozial - positiv",
      it: "Sociale - positivo",
    },
  },
  {
    value: "behav14",
    label: "Toilettage et maintenance",
    categoryId: "behav14",
    categorieName: "Toilettage et maintenance",
    color: "#CCCCFF", // Legacy color from colors.js
    trans: {
      fr: "Toilettage et maintenance",
      en: "Grooming and maintenance",
      es: "Aseo y mantenimiento",
      nl: "Verzorging en onderhoud",
      de: "Pflege und Instandhaltung",
      it: "Toelettatura e manutenzione",
    },
  },
  {
    value: "behav15",
    label: "Vigilance",
    categoryId: "behav15",
    categorieName: "Vigilance",
    color: "#660FB5", // Legacy color from colors.js
    trans: {
      fr: "Vigilance",
      en: "Vigilance",
      es: "Vigilancia",
      nl: "Waakzaamheid",
      de: "Vigilanz",
      it: "Vigilanza",
    },
  },
]

export const OBS_QUESTION_PROFILE = [
  {
    optionProfileId: "cat1:1",
    categoryId: "cat1",
    optionText: {
      fr: "Vigilance, observation (assis, debout, allongé)",
    },
    helpIsActive: true,
    helpData: {
      helpText: { fr: "Aide" },
      helpIllustration: [],
    },
    isAbnormal: false,
    label: "NOM DANS LE SELECTEUR",
    value: "NE PAS REMPLIR",
  },

  {
    optionProfileId: "cat1:2",
    categoryId: "cat1",
    optionText: "Menace (cri d'alarme, montre les dents, posture face à l'observateur), etc.",
    helpData: {
      helpText: "A l'arrivée de l'observateur, se déplace hors de sa vue dans un trou de tanière ou dans un endroit invisible pour éviter un danger potentiel",
      helpIllustration: [],
    },
    isAbnormal: false,
  },
  {
    optionProfileId: "cat1:3",
    categoryId: "cat1",
    optionText: "Fuit / se cache (à l'arrivée de l'observateur)",
    helpData: null,
    isAbnormal: false,
  },
  {
    optionProfileId: "cat1:4",
    categoryId: "cat1",
    optionText: "Sollicitation (s'approche, recherche de contact, s'allonge, etc.)",
    helpData: null,
    isAbnormal: false,
  },

  {
    optionProfileId: "cat2:1",
    categoryId: "cat2",
    optionText: "Saute",
    helpData: null,
    isAbnormal: false,
  },
  {
    optionProfileId: "cat2:2",
    categoryId: "cat2",
    optionText: "Grimpe",
    isAbnormal: false,
    helpData: null,
  },
  {
    optionProfileId: "cat2:3",
    categoryId: "cat2",
    optionText: "Marche",
    isAbnormal: false,
    helpData: {
      helpText: "Se déplace à un rythme lent",
      helpIllustration: [],
    },
  },
  {
    optionProfileId: "cat2:4",
    categoryId: "cat2",
    optionText: "Cours",
    isAbnormal: false,
    helpData: null,
  },
  {
    optionProfileId: "cat2:5",
    categoryId: "cat2",
    optionText: "Gratte, creuse",
    isAbnormal: false,
    helpData: {
      helpText: "Utilise ses pattes avant pour faire un trou dans le substrat",
      helpIllustration: [],
    },
  },
  {
    optionProfileId: "cat2:6",
    categoryId: "cat2",
    isAbnormal: false,
    optionText: "Exploration (renifle un enrichissement, etc.)",
    helpData: null,
  },
  {
    optionProfileId: "cat2:7",
    categoryId: "cat2",
    isAbnormal: false,
    optionText: "Joue (avec objet ou seul - hors congénères)",
    helpData: null,
  },
  {
    optionProfileId: "cat2:8",
    categoryId: "cat2",
    isAbnormal: false,
    optionText: "Se déplace de façon répétitive (ex : en cercle, allers-retours devant une vitre, etc.)",
    helpData: null,
  },

  {
    optionProfileId: "cat3:1",
    categoryId: "cat3",
    isAbnormal: false,
    optionText: "Grooming / toilettage",
    helpData: null,
  },
  {
    optionProfileId: "cat3:2",
    categoryId: "cat3",
    isAbnormal: false,
    optionText: "Contact affiliatif (touche le museau, renifle, lèche)",
    helpData: null,
  },
  {
    optionProfileId: "cat3:3",
    categoryId: "cat3",
    isAbnormal: false,
    optionText: "Jeu avec congénères",
    helpData: null,
  },
  {
    optionProfileId: "cat3:4",
    categoryId: "cat3",
    isAbnormal: false,
    optionText: "Accouplement / monte",
    helpData: null,
  },
  {
    optionProfileId: "cat3:5",
    categoryId: "cat3",
    isAbnormal: false,
    optionText: "Agression avec contact (ex: mordre / griffer / tirer les poils)",
    helpData: null,
  },
  {
    optionProfileId: "cat3:6",
    categoryId: "cat3",
    isAbnormal: false,
    optionText: "Agression sans contact (ex : menace, poursuite, vocalisations, secoue une branche, etc.)",
    helpData: null,
  },
  {
    optionProfileId: "cat3:7",
    categoryId: "cat3",
    isAbnormal: false,
    optionText: "Vol d'objet (ex: enrichissement)",
    helpData: null,
  },
  {
    optionProfileId: "cat3:8",
    categoryId: "cat3",
    isAbnormal: false,
    optionText: "Vol de nourriture",
    helpData: null,
  },
  {
    optionProfileId: "cat3:9",
    isAbnormal: false,
    categoryId: "cat3",
    optionText: "Evite un congénère (ex: fuit, se cache, se met en hauteur, etc.)",
    helpData: null,
  },

  {
    optionProfileId: "cat4:1",
    categoryId: "cat4",
    isAbnormal: false,
    optionText: "Mange, boit",
    helpData: null,
  },
  {
    optionProfileId: "cat4:2",
    categoryId: "cat4",
    isAbnormal: false,
    optionText: "Se déplace avec de la nourriture",
    helpData: null,
  },
  {
    optionProfileId: "cat4:3",
    categoryId: "cat4",
    isAbnormal: false,
    optionText: "Fourrage (ex: renifle, gratte le sol)",
    helpData: {
      helpText: "Regarde en haut, en bas, sur le côté, avec ou sans mouvement de la tête, regard dirigé vers une cible - suivi visuel d'autres individus",
    },
  },
  {
    optionProfileId: "cat4:5",
    isAbnormal: false,
    categoryId: "cat4",
    optionText: "Manipule un objet contenant de la nourriture (puzzle feeder)",
    helpData: null,
  },

  {
    optionProfileId: "cat5:1",
    isAbnormal: false,
    categoryId: "cat5",
    optionText: "Vigilance, observation",
    helpData: null,
  },
  {
    optionProfileId: "cat5:2",
    isAbnormal: false,
    categoryId: "cat5",
    optionText: "Inactif / Repos",
    helpData: null,
  },
  {
    optionProfileId: "cat5:3",
    isAbnormal: false,
    categoryId: "cat5",
    optionText: "Baille",
    helpData: null,
  },
  {
    optionProfileId: "cat5:4",
    isAbnormal: false,
    categoryId: "cat5",
    optionText: "Se toilette / se lave",
    helpData: null,
  },

  {
    optionProfileId: "cat5:6",
    isAbnormal: false,
    categoryId: "cat5",
    optionText: "Maintenance : uriner, défequer",
    helpData: null,
  },
  {
    optionProfileId: "cat5:7",
    isAbnormal: false,
    categoryId: "cat5",
    optionText: "Marquage avec urine (sur lui-même / objet)",
    helpData: null,
  },
  {
    optionProfileId: "cat5:8",
    isAbnormal: false,
    categoryId: "cat5",
    optionText: "Jeu (seul)",
    helpData: null,
  },
  {
    optionProfileId: "cat5:9",
    isAbnormal: false,
    categoryId: "cat5",
    optionText: "Coprophagie",
    helpData: null,
  },
  {
    optionProfileId: "cat5:10",
    isAbnormal: false,
    categoryId: "cat5",
    optionText: "Se mord (patte, queue, etc.)",
    helpData: null,
  },
  {
    optionProfileId: "cat5:11",
    isAbnormal: false,
    categoryId: "cat5",
    optionText: "Mouvement de tête répétitif",
    helpData: null,
  },
  {
    optionProfileId: "cat5:12",
    isAbnormal: false,
    categoryId: "cat5",
    optionText: "Mord ou lèche les barreaux/ l'enclos",
    helpData: null,
  },

  {
    optionProfileId: "cat6:1",
    isAbnormal: false,
    categoryId: "cat6",
    optionText: "Vocalisation liée à l'alimentation",
    helpData: null,
  },
  {
    optionProfileId: "cat6:2",
    isAbnormal: false,
    categoryId: "cat6",
    optionText: "Vocalisation liée à une agression",
    helpData: null,
  },
  {
    optionProfileId: "cat6:3",
    isAbnormal: false,
    categoryId: "cat6",
    optionText: "Vocalisations de contact",
    helpData: null,
  },
  {
    optionProfileId: "cat6:4",
    isAbnormal: false,
    categoryId: "cat6",
    optionText: "Cri d'alarme",
    helpData: null,
  },

  {
    optionProfileId: "cat0:1",
    isAbnormal: false,
    categoryId: "cat0",
    optionText: "Non visible",
    helpData: null,
  },
  {
    optionProfileId: "cat0:2",
    isAbnormal: false,
    categoryId: "cat0",
    optionText: "Indéterminé",
    helpData: null,
  },

  //

  {
    optionProfileId: "cat0:custom",
    isAbnormal: false,
    categoryId: "cat0",
    optionText: "",
    helpData: null,
  },
  {
    optionProfileId: "cat1:custom",
    isAbnormal: false,
    categoryId: "cat1",
    optionText: "",
    helpData: null,
  },
  {
    optionProfileId: "cat2:custom",
    isAbnormal: false,
    categoryId: "cat2",
    optionText: "",
    helpData: null,
  },
  {
    optionProfileId: "cat3:custom",
    isAbnormal: false,
    categoryId: "cat3",
    optionText: "",
    helpData: null,
  },
  {
    optionProfileId: "cat4:custom",
    isAbnormal: false,
    categoryId: "cat4",
    optionText: "",
    helpData: null,
  },
  {
    optionProfileId: "cat5:custom",
    isAbnormal: false,
    categoryId: "cat5",
    optionText: "",
    helpData: null,
  },
  {
    optionProfileId: "cat6:custom",
    isAbnormal: false,
    categoryId: "cat6",
    optionText: "",
    helpData: null,
  },
]
